import { SelectOptions } from "../select-options";

export const nationalDeliveryPayTypeOptions = [
  {
    id: 1,
    mainText: "online",
  },
  {
    id: 2,
    mainText: "cash",
  },
];

export default function SelectNationalDeliveryPayTypeFlow({
  onSelect,
}: {
  onSelect: (selectedValue: any) => void;
}) {
  return (
    <SelectOptions
      options={nationalDeliveryPayTypeOptions}
      onSelect={onSelect}
      hideSearch
      translation
    />
  );
}
